export const getAuthToken = () => {
  const currentUser = localStorage.getItem("currentUser");

  return currentUser ? JSON.parse(currentUser).token : null;
};
